import React, {useEffect, useState} from "react";
import login from "assets/Login/signup-img.png";
import Button from "components/molecules/Button";
import Field from "components/molecules/Field";
import Form from "components/molecules/Form/Form";
import {useForm} from "components/molecules/Form";
import Heading from "components/atoms/Auth/Heading";
import OnBoardingLayout from "components/atoms/Auth/OnBoardingLayout";
import {Link, useNavigate} from "react-router-dom";
import authService from "services/authService";
import Toast from "components/molecules/Toast";
import userService from "services/userService";
const Signup = () => {
    const [form] = useForm();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    async function handleSubmit(e) {
        const payload = {
            first_name: e.first_name,
            last_name: e.last_name,
            email: e.email,
            password: e.confirm_password,
            phone: e.phone,
            websiteSource: process.env.REACT_APP_WEBSITE_SOURCE,
        };
        try {
            setLoading(true);
            const res = await authService.signUp(payload);
            sessionStorage.setItem("userEmail", e.email);
            Toast({type: "success", message: res.message});
            setLoading(false);
            navigate("/signup-verify-otp");
        } catch (err) {
            setLoading(false);
            Toast({type: "error", message: err.message});
        }
    }
    return (
        <>
            <OnBoardingLayout img={login}>
                <Heading heading="Are you prepared to expand your Business?" />
                <Form form={form} onSubmit={handleSubmit}>
                    <div className="signup-fields">
                        <Form.Item
                            label="First Name"
                            type="name"
                            rounded
                            name="first_name"
                            lg
                            placeholder="First Name"
                            $bgWhite
                            rules={[
                                {
                                    required: true,
                                    message: "First name is required",
                                },
                            ]}>
                            <Field />
                        </Form.Item>
                        <Form.Item
                            label="Last Name"
                            type="name"
                            rounded
                            name="last_name"
                            lg
                            placeholder="Last Name"
                            $bgWhite
                            rules={[
                                {
                                    required: true,
                                    message: "Last name is required",
                                },
                            ]}>
                            <Field />
                        </Form.Item>
                    </div>
                    <Form.Item
                        label="Email address"
                        type="email"
                        rounded
                        name="email"
                        lg
                        placeholder="Enter your email address"
                        $bgWhite
                        rules={[
                            {
                                required: true,
                                message: "Email is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                    <Form.Item
                        label="Create Password"
                        type="password"
                        rounded
                        name="password"
                        lg
                        placeholder="Enter Password"
                        $bgWhite
                        rules={[
                            {
                                required: true,
                            },
                            {
                                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,64}$/,
                                message: "8-64 characters, include, uppercase, lowercase, number, and symbol.",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                    <Form.Item
                        label="Confirm Password"
                        type="password"
                        rounded
                        name="confirm_password"
                        lg
                        placeholder="Confirm Password"
                        $bgWhite
                        rules={[
                            {
                                required: true,
                            },
                            {
                                transform: value => value !== form.getFieldValue("password"),
                                message: "The two passwords that you entered do not match!",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                    <Form.Item
                        label="Phone Number"
                        type="phone"
                        rounded
                        name="phone"
                        lg
                        placeholder="Enter your Phone No"
                        bgWhite="white"
                        onChange={e => form.setFieldsValue({phone: e})}
                        rules={[
                            {
                                required: true,
                                message: "Phone number is required",
                            },
                            {
                                pattern: /^(?:\+1|1)?\s?(?:\([2-9]\d{2}\)|[2-9]\d{2})[\s.-]?[2-9]\d{2}[\s.-]?\d{4}$/,
                                message: "Enter a valid phone number",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                    <div className="btn-holder">
                        <Button lg loader={loading}>
                            Get Started
                        </Button>
                        <div className="textWrapper">
                            <span>Already have an account? &nbsp;</span>
                            <Link to="/" className="linkSignup">
                                Sign In
                            </Link>
                        </div>
                    </div>
                </Form>
            </OnBoardingLayout>
        </>
    );
};

export default Signup;
